import React from "react";
import { Button, Modal } from "react-bootstrap";
import useLocalStorage from "../hooks/useLocalStorage.js";

const ConsentModal = () => {
  const [hasConsent, setHasConsent] = useLocalStorage(
    "rekognitionEngagementMeterConsent",
    false
  );

  const onClick = () => {
    setHasConsent(true);
  };

  return (
    <Modal show={!hasConsent} backdrop="static">
      <Modal.Header>
        <Modal.Title>Políticas de Privacidad</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
       La información biométrica que se genera como parte de este proceso será retenida de acuerdo con la política de privacidad de DANAconnect. Por la presente, usted proporciona su consentimiento expreso, informado y por escrito para que los servicios DANAconnect y AWS recopilen, utilicen y almacenen sus datos biométricos para análisis, verificación de fraude y propósitos de seguridad.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClick}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConsentModal;
